<template>
  <div class="content">
    <van-nav-bar title="订单结算" @click-left="onClickLeft">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;"  :src="require('../../assets/'+appTheme+'/navBack.png')" alt="" />
      </template>
      <!--      <template #right>-->
      <!--        <img style="width: 4.93333vw;height: auto;display: inline-block;" src="../../assets/car_icon.png" alt="">-->
      <!--      </template>-->
    </van-nav-bar>
    <div class="block-address">
      <div @click="goToAddress" class="address-picker justify-align">
        <div>
          <div class="" v-if="address">
            <div class="address-name left-justifying">
              <div class="" style="max-width: 30.66667vw">{{address.name}}</div>
              <div class="address-phone">{{address.tel}}</div>
            </div>
            <div class="address" v-if="addressType==1">收货地址：{{address.address}}</div>
            <div class="address" v-else>收货地址：{{address.area}} {{address.address}}</div>
          </div>
          <div class="flex-grow-1" v-else>
            <div style="color:#ff4544">请选择收货地址</div>
          </div>
        </div>
        <div class="flex-grow-0 flex-y-center">
          <van-icon name="arrow" color="#ccc" />
        </div>
      </div>
    </div>
    <div class="mch-item">
      <div class="mch-header left-justifying" v-if="goodsList !=''"><img class="shop-icon" :src="require('../../assets/'+appTheme+'/shop_icon.png')" alt="" /> {{goodsList[0].shop.name}}</div>
      <div class="cart-list">
        <div class="cart-item border-bottom" v-for="(item, b) in goodsList" :key="b">
          <div class="left-justifying">
            <div class="flex-grow-0">
              <img class="goods-pic" :src="item.goods.image" />
            </div>
            <div class="goods-content">
              <div class="flex-grow-1">
                <div class="goods-name">
                  <!--                  <span>￥1</span>  -->
                  {{item.goods.name}}</div>
                <!--                <div class="attr-list">-->
                <!--                  <div class="attr-item" v-for="(attr,j) in goods.attr_list" :key="j">-->
                <!--                    {{attr.attr_group_name}}:{{attr.attr_name}}-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
              <div class="" style="text-align: right">
                <div class="flex-grow-0 price">￥{{item.goods.price}}</div>
                <div class="num">×{{item.number}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ticket-box">
      <!-- 优惠券单元格 -->
      <div class="justify-align discount-box freight-box" v-if="couponList.length>0" @click="showList = true">
        优惠券
        <div class="left-justifying">
          <span style="color: #F23926">{{bonus_des}}</span>
          <img style="margin-left: 2.66667vw;" :src="require('../../assets/'+appTheme+'/order_right.png')" alt="" />
        </div>

      </div>
      <!-- 优惠券列表 -->
      <van-popup
        v-model="showList"
        round
        position="bottom"
        style="padding-top: 0.53333vw;"
      >
        <div class="ticket-list">
          <div class="ticket-title">优惠券</div>
          <div class="discount-coupon-box">
            <van-radio-group v-model="radio">
              <div class="discount-coupon-item justify-align" v-for="(item,index) in couponList" :key="index">
                <div>
                  <div class="coupon-item-title" style="color: #000;">{{item.title}}</div>
                  <div class="price-hint" v-if="item.type=='subsidy'">
                    <div class="left-justifying" style="color: #666;">代金券<div style="color: #fa2424;"><span>￥</span>{{item.preferential_amount}}</div></div>
                    <div style="color: #666;" class="" v-if="item.sufficient_amount !='0.00'"><span>满</span> {{item.sufficient_amount}} <span>可用</span></div>
                  </div>
                  <div class="discount-hint" v-if="item.type=='discount'">
                    <span style="color: #fa2424;">{{item.discount |filterDiscount}}折</span>
                  </div>
                </div>

                <van-radio :name="index" checked-color="#F23926"></van-radio>
              </div>
            </van-radio-group>
          </div>
          <div class="discount-coupon-btn" @click="discountsPriceClick">确定</div>
        </div>
      </van-popup>
      <div class="justify-align freight-box">
        消费总额 <span style="font-size: 3.2vw;color: #282828;">￥{{totalMoney}}</span>
      </div>
      <div class="justify-align freight-box">
        优惠金额 <span style="color: #F23926;font-size: 3.2vw;">-￥{{discountsPrice==''?'0':discountsPrice}}</span>
      </div>
      <div class="freight-box" style="text-align: right;">
        合计金额： <span style="color: #F23926;font-size: 3.73333vw;">￥{{sumPrice}}</span>
      </div>
    </div>

    <div class="" style="margin-top: 2.66667vw">
      <van-field
        v-model="message"
        rows="1"
        autosize
        label="订单备注"
        type="textarea"
        maxlength="64"
        placeholder="请填写订单备注"
      />
    </div>
    <div @click="onSubmit" class="submitBtn">￥{{sumPrice}}元确定下单</div>
  </div>
</template>

<script>
import navBar from "@/components/navBar";
import {cartOrderSubmit} from "@/api/order";
import {cartCheckout} from "@/api/cart";
import cal from '@/utils/calculation';

export default {
  name: "cartPay",
  data(){
    return {
      appTheme:this.$store.state.appTheme,
      goodsList: [],
      totalMoney:0, // 消费总金额
      discountsPrice: '', /// 优惠券金额
      sumPrice: '', // 合计金额
      couponList1: [{name:'省1：组合优惠  ￥1', price: 1,type:0},{name:'省0.1：组合优惠  ￥0.10', price: 0.1,type:1}],
      couponList:[],
      radio: -1,
      chosenCoupon: -1,
      showList:false,
      address: '',
      addressType: 0, // 0请求地址 1自己选择的地址
      message: '',
      submitNumber: '', // 非等于空 商品详情页进来  // 为空购物车进来
      goodsInfo: '',
      title: '订单结算',
      cart_ids:'',
      shop_id: '',
      bonus_des:'',
      bonus_id: null
    }
  },
  components: {

  },
  filters: {
    filterDiscount: function (value){
      var discount = value/10
      return discount
    }
  },
  created() {
    console.log('cartids', this.$route.query.cartids.length)
    console.log('shopId', this.$route.query.shopid)
    if (this.$route.query.shopid != undefined) { // 购物车进来
      this.cart_ids = JSON.parse(this.$route.query.cartids)
      this.shop_id = this.$route.query.shopid
      this.getPayInfo()
      // console.log('正常进来')
    } else { // 地址进来 刷新
      // console.log('地址')
      var cartIds = JSON.parse(this.$store.state.cartIds)
      // console.log(cartIds)
      this.cart_ids = cartIds
      this.shop_id = this.$store.state.shopId
      // console.log(this.shop_id)
      this.getPayInfo()
    }
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload",()=>{
      var cartIds = JSON.stringify(this.cart_ids)
      this.$store.commit("setCartIds", cartIds);
      this.$store.commit("setShopId",this.shop_id)
    })
  },
  methods: {
    onClickLeft() {
      // 清掉存储的goodsInfo
      this.$store.commit("setCartIds",'');
      this.$store.commit("setShopId",'')
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    getPayInfo(){ // 获取提交订单信息
      // console.log(this.cart_ids.length)
      var cart_ids = this.cart_ids
      // var arr = [638,524]
      // arr = cart_ids
      var data = {
        shop_id: this.shop_id,
        cart_ids:this.cart_ids, // JSON.stringify(cart_ids)
        selected_bonus_id: this.bonus_id !=''? this.bonus_id:''
      }
      // const res = await this.$Http.getCheckoutPay(data)
      cartCheckout(data).then(res => { // getCheckoutPay
        if(res.code == 200)
        {
          this.goodsList = res.data.cart
          this.couponList = res.data.bonus
          let resData= res.data
          this.totalMoney = resData.total // 总金额
          this.sumPrice = resData.payment_amount
          this.discountsPrice = resData.preferential_total
          var currIndex = this.radio
          let bonusItem = ''
          this.couponList.forEach(function(value,index){
            if (value.selected == true){ // 折扣券跟当前选中的id
              // this.radio = index
              currIndex = index
              // console.log('value',value)
              bonusItem = value

            }
          })
          this.radio = currIndex // 赋值选中 id
          this.bonus_id = bonusItem.id
          this.bonus_des = bonusItem.title
          this.bonus_info = bonusItem


          const info = this.$store.state.addressInfo
          // console.log(info)
          if (info != false){ // // 0请求地址 1自己选择的地址
            this.addressType = 1
            this.address = this.$store.state.addressInfo
            console.log(this.address)
          }else{ // 获取返回的
            this.address = res.data.address
          }
        }else {
          // this.$toast(res.message)
          this.$dialog.alert({
            title: '提示',
            message: res.message,
          }).then(() => {
            // on close
            this.$router.go(-1)
          });
        }
      })
    },
    // 计算总价
    totalPrice() {
      let cartList = this.goodsList;
      let total = 0;
      let goods_num = 0;
      for (let i = 0; i < cartList.length; i++) {
        total += cartList[i].goods.price * cartList[i].number;
        goods_num += cartList[i].number;
      }
      // this.totalMoney = total.toFixed(2);

      let y_total = String(total).indexOf(".") + 1;//获取小数点的位置
      if(y_total > 0) { // 判断是否有小数
        // alert("这个数字是小数，有" + ',' + "位小数");
        let totals = this.getnum(total) // 保留2位小数
        this.totalMoney = totals // 折扣减价格
      } else {
        // alert("不是小数");
        this.totalMoney = total+'.00' // 折扣减价格
      }


    },
    discountsPriceClick(){ // 计算折扣价
      this.showList = false
      if (this.radio != -1){

        this.bonus_id = this.couponList[this.radio].id
        this.bonus_des = this.couponList[this.radio].title
        this.getPayInfo()

      } else {
        console.log('bu要计算')
      }
      // this.couponList[this.radio]
      // console.log( this.couponList[this.radio])
      console.log('当选中index',this.radio)
    },
    goToAddress(){
      // const addDate = JSON.stringify(item)
      var catrt_ids = JSON.stringify(this.cart_ids)
      this.$store.commit("setCartIds", catrt_ids);
      this.$store.commit("setShopId",this.shop_id)

      this.$router.push({path:'/addressList',query: {type:2}})
    },
    onSubmit(){
      var that = this
      var address = that.address
      console.log(address)
      if (address==null){
        this.$toast('请选择地址')
        return false
      }
      var data = {
        shop_id: this.shop_id,
        cart_ids:this.cart_ids, // JSON.stringify(cart_ids)
        address_id: address.id,
        bonus_id: this.bonus_id, // 优惠券id
        message: this.message

      }
      // 购物车车下单进入 cartCome：1

      cartOrderSubmit(data).then(res => {
        if(res.code == 200)
        {
          // this.$toast(res.message)
          console.log(res.data)
          // 为了处理后退不下单开始
          var payData = JSON.stringify(res.data)
          this.$router.push({path:'/submitOrder',query: {pay:payData,cartCome:1}})
          // 为了处理后退不下单end
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    getnum(num){
      num = String(num)
      return num.substring(0,num.indexOf(".")+3);
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  padding-bottom: 60px;
}
.ticket-list{
  padding-bottom: 30px;
  .ticket-title{
    font-size: 30px;padding: 20px 20px;font-weight: 400;
    color: #282828;
  }
  .discount-coupon-box{
    padding: 0 20px;margin-top: 20px;
    .discount-coupon-item{

      font-size: 24px;
      padding: 15px 10px;
      border: 1px solid #F5F5F5;margin-bottom: 10px;
      .coupon-item-title{
        font-size: 28px;padding-bottom: 5px;
      }
    }
    height: 60%;margin-bottom: 20px;overflow-y: auto;
  }
  .discount-coupon-btn{
    width: 577px;
    font-weight: bold;font-size: 32px;padding: 18px 0;text-align: center;
    background: #FDD80D;
    border-radius: 41px;margin: 0 auto 20px;
  }
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.submitBtn{
  width: 570px;
  text-align: center;margin: 211px auto 20px;padding: 20px 0;
  background: #FDD80D;
  border-radius: 45px;font-size: 38px;font-weight: bold;
}
.van-cell::after {
  border-bottom: none;
}
.ticket-box{
  color: #282828;font-size: 24px;
  .discount-box{
    img{
      width: 14px;height: auto;display: block;
    }
  }
}
.mt20{
  margin-top: 20px;
}
.freight-box{
  padding: 24px 32px;background: #ffffff;font-size: 28px;
}
.block-address{
  background: #ffffff;padding: 20px;text-align: left;font-size: 28px;
  .address-name{
    margin-bottom: 20px;
    font-weight: bold;
    color: #000000;font-size: 30px;
    .address-phone{
      margin-left: 30px;
    }
  }
  .address{
    white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 24px;color: #000000;
  }
}
.level-price{
  color:#ff4544;text-align:right;margin-bottom:22px;
}
.pay-way{
  background: #fff;padding: 24px 24px;margin-bottom: 20px;margin-top: 10px;
  .pay-txt{
    font-size: 26px;

  }
}
.mch-item{
  margin-top: 20px;background: #ffffff;
  .mch-header{
    padding: 20px 24px;background: #ffffff;text-align: left;
    .shop-icon{
      width: 24px;height: auto;display: inline-block;margin-right: 15px;
    }
  }
  .goods-content{
    width: 75%;
    .flex-grow-1{
      text-align: left;
    }
  }
}
.cart-item {
  background: #fff;
  padding-bottom: 20px;
  margin: 32px 24px 0 24px;border-bottom: 2px solid #E5E5E5;
}

.cart-item .goods-pic {
  width: 164px;
  height: 164px;
  border-radius: 15px;
  margin-right: 20px;
}

.cart-item .goods-name {
  font-weight: bold;
  color: #636363;font-size: 28px;
  margin-bottom: 10px;
  span{
    display: inline-block;
    padding: 0 10px;
    background: #F23926;
    border-radius: 5px;font-size: 18px;color: #FFFFFF;font-weight: bold;text-align: center;
  }
}

.cart-item .attr-list,.cart-item .num {
  font-size: 20px;
  color: #A4A4A4;text-align: right;
}

.cart-item .attr-list .attr-item {
  display: inline-block;
  margin-right: 36px;
}

.cart-item .attr-list .attr-item:last-child {
  margin-right: 0;
}

.cart-item .price {
  color: #F23926;font-size: 28px;font-weight: 500;
}

</style>
